import { add, endOfMonth, format } from 'date-fns';
import { useState } from 'react';

import mboApi from 'infrastructure/redux/adapters/mboAPI/mboApi';

interface UseFirstLessonAvailableDates {
  locationId: string;
}

const useFirstLessonAvailableDates = ({ locationId }: UseFirstLessonAvailableDates) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(endOfMonth(add(new Date(), { months: 1 })));

  const handleFetchFurtherAvailableDates = (newDate: Date | null) => {
    if (newDate) {
      setEndDate(endOfMonth(add(newDate, { months: 1 })));
    }
  };

  const {
    data: firstLessonAvailableDates,
    isLoading: areFirstLessonAvailableDatesLoading,
    error: firstLessonAvailableDatesError,
    isFetching: areFirstLessonAvailableDatesFetching,
  } = mboApi.useGetAvailableFirstLessonDatesQuery(
    {
      locationId,
      startDateTime: format(startDate, 'yyyy-MM-dd'),
      endDateTime: format(endDate, 'yyyy-MM-dd'),
    },
    {
      skip: !locationId || !startDate || !endDate,
      refetchOnMountOrArgChange: true,
    },
  );

  return {
    firstLessonAvailableDates,
    areFirstLessonAvailableDatesLoading,
    firstLessonAvailableDatesError,
    areFirstLessonAvailableDatesFetching,
    setFirstLessonAvailableDatesStartDate: (value: Date) => setStartDate(value),
    setFirstLessonAvailableDatesEndDate: (value: Date) => setEndDate(value),
    fetchFurtherAvailableDates: handleFetchFurtherAvailableDates,
  };
};

export default useFirstLessonAvailableDates;
